import React, { memo, useMemo, useRef, useState, useCallback, useEffect } from 'react';
import classnames from 'classnames';
import * as Tracking from 'utils/tracking';
import useLoginLiterals from 'utils/literals/useLoginLiterals';
import SignupStart from './SignupStart';
import SignupExtra from './SignupExtra';
import SignupEmailVerification from './SignupEmailVerification';
import SignupCreating from './SignupCreating';
import SignupError from './SignupError';

import Logo from 'components/Logo';

import './styles.scss';

const Signup = memo(({}) => {
    const data = useRef({});
    const [step, setStep] = useState(0);
    const { loading, getLiteral } = useLoginLiterals();
    const isIframe = window.top !== window.self;

    const rootClassName = classnames('signup', {
        'signup--no-iframe': !isIframe,
    });

    const onStep = useCallback(
        (deltaStep, info = {}) => {
            setStep(step + deltaStep);
            data.current = {
                ...data.current,
                ...info,
            };
        },
        [step],
    );
    const steps = useMemo(
        () => [
            {
                component: SignupStart,
                props: {
                    t: getLiteral,
                    onStep,
                },
            },
            {
                component: SignupEmailVerification,
                props: {
                    t: getLiteral,
                    onStep,
                    data,
                },
            },
            {
                component: SignupExtra,
                props: {
                    t: getLiteral,
                    onStep,
                },
            },
            {
                component: SignupCreating,
                props: {
                    t: getLiteral,
                    onStep,
                    data,
                },
            },
            {
                component: SignupError,
                props: {
                    t: getLiteral,
                    onStep,
                    data,
                },
            },
        ],
        [getLiteral, onStep],
    );

    useEffect(() => {
        Tracking.initWithoutId();
    }, []);

    if (loading) return null;

    return (
        <div className={rootClassName}>
            <div className="signup__content">
                {!isIframe && <Logo />}
                <div className="signup__steps">
                    {steps.map((item, idx) => (
                        <div
                            className={classnames('signup__step', {
                                'signup__step--active': idx === step,
                            })}
                        >
                            <item.component {...item.props} active={idx === step} />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
});

export default Signup;
